import { Record } from 'immutable';

const RatePlanCodeValidationRequestRecord = Record({
  eventId: null,
  eventPartyId: null,
  chain: null,
  brand: null,
  propertyId: null,
  ratePlanCodes: null,
  startDate: null,
  endDate: null
});

export class RatePlanCodeValidationRequest extends RatePlanCodeValidationRequestRecord {
  eventId: number;
  eventPartyId: number;
  chain: string;
  brand: string;
  propertyId: string;
  ratePlanCodes: string[];
  startDate: string;
  endDate: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code-validation-request.ts